import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../PasswordProtectionUnlock.module.scss';
import { PublicImage } from '@/components/common/PublicImage/PublicImage';
import {
  Button,
  EButtonHierarchy,
  EButtonSize,
  EButtonStyle,
} from '@/components/common/Button/Button';

interface IForgotPasswordViewProps {
  readonly onApprove: () => Promise<void>;
  readonly onCancel: () => void;
}

export const ForgotPasswordView: React.FC<IForgotPasswordViewProps> = ({
  onApprove,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.forgotPasswordViewWrapper}>
      <PublicImage
        className={styles.unlockImg}
        src="/images/blockpage/secure-password.svg"
        alt={t('blockPage.unlock.resetPasswordTitle')}
      />
      <div className={styles.unlockTitle}>
        {t('blockPage.unlock.resetPasswordTitle')}
      </div>
      <div className={styles.unlockDescription}>
        {t('blockPage.unlock.resetPasswordDescription')}
      </div>
      <div className={styles.unlockButtons}>
        <Button
          onClick={onCancel}
          hierarchy={EButtonHierarchy.primary}
          buttonStyle={EButtonStyle.tonal}
          fillWidth={true}
          size={EButtonSize.lg}
          text="blockPage.unlock.resetPasswordCancel"
        />
        <Button
          onClick={onApprove}
          hierarchy={EButtonHierarchy.primary}
          fillWidth={true}
          size={EButtonSize.lg}
          text="blockPage.unlock.resetPasswordApprove"
        />
      </div>
    </div>
  );
};
